const SettingsActionTypes = {
    GET_ENV_JSON: 'GET_ENV_JSON',
    SUCCESS_ENV_JSON: 'SUCCESS_ENV_JSON',
    FAILURE_ENV_JSON: 'FAILURE_ENV_JSON',

    FETCH_DOCUMENT_REQUEST: 'FETCH_DOCUMENT_REQUEST',
    SUCCESS_DOCUMENT_REQUEST: 'SUCCESS_DOCUMENT_REQUEST',
    FINISH_DOCUMENT_REQUEST: 'FINISH_DOCUMENT_REQUEST',
    FAILURE_DOCUMENT_REQUEST: 'FAILURE_DOCUMENT_REQUEST',

    START_UPLOAD_DOCUMENTS: 'START_UPLOAD_DOCUMENTS',
    SUCCESS_UPLOAD_DOCUMENTS: 'SUCCESS_UPLOAD_DOCUMENTS',
    FINISH_UPLOAD_DOCUMENTS: 'FINISH_UPLOAD_DOCUMENTS',
    FAILURE_UPLOAD_DOCUMENTS: 'FAILURE_UPLOAD_DOCUMENTS',

    START_CHANGE_PASSWORD: 'START_CHANGE_PASSWORD',
    SUCCESS_CHANGE_PASSWORD: 'SUCCESS_CHANGE_PASSWORD',
    FINISH_CHANGE_PASSWORD: 'FINISH_CHANGE_PASSWORD',
    FAILURE_CHANGE_PASSWORD: 'FAILURE_CHANGE_PASSWORD',

    FETCH_ON_PAGE_LOAD: 'FETCH_ON_PAGE_LOAD',

    FETCH_SUPPORTED_CURRENCIES: 'FETCH_SUPPORTED_CURRENCIES',
    SUCCESS_SUPPORTED_CURRENCIES: 'SUCCESS_SUPPORTED_CURRENCIES',

    FETCH_SUPPORTED_LANGUAGES: 'FETCH_SUPPORTED_LANGUAGES',
    SUCCESS_SUPPORTED_LANGUAGES: 'SUCCESS_SUPPORTED_LANGUAGES',

    FETCH_SUPPORT_CONVERSATIONS: 'FETCH_SUPPORT_CONVERSATIONS',
    SUCCESS_SUPPORT_CONVERSATIONS: 'SUCCESS_SUPPORT_CONVERSATIONS',
    FAILURE_SUPPORT_CONVERSATIONS: 'FAILURE_SUPPORT_CONVERSATIONS',

    FETCH_SUPPORT_UNREAD_CONVERSATIONS_COUNT: 'FETCH_SUPPORT_UNREAD_CONVERSATIONS_COUNT',
    SUCCESS_SUPPORT_UNREAD_CONVERSATIONS_COUNT: 'SUCCESS_SUPPORT_UNREAD_CONVERSATIONS_COUNT',
    FAILURE_SUPPORT_UNREAD_CONVERSATIONS_COUNT: 'FAILURE_SUPPORT_UNREAD_CONVERSATIONS_COUNT',

    GET_SUPPORT_CONVERSATION_DETAILS: 'GET_SUPPORT_CONVERSATION_DETAILS',
    SUCCESS_SUPPORT_CONVERSATION_DETAILS: 'SUCCESS_SUPPORT_CONVERSATION_DETAILS',
    FAILURE_SUPPORT_CONVERSATION_DETAILS: 'FAILURE_SUPPORT_CONVERSATION_DETAILS',

    START_SUPPORT_CONVERSATION_FILE: 'START_SUPPORT_CONVERSATION_FILE',
    SUCCESS_SUPPORT_CONVERSATION_FILE: 'SUCCESS_SUPPORT_CONVERSATION_FILE',
    FINISH_SUPPORT_CONVERSATION_FILE: 'FINISH_SUPPORT_CONVERSATION_FILE',
    FAILURE_SUPPORT_CONVERSATION_FILE: 'FAILURE_SUPPORT_CONVERSATION_FILE',

    FETCH_SUPPORT_DEPARTMENTS: 'FETCH_SUPPORT_DEPARTMENTS',
    SUCCESS_SUPPORT_DEPARTMENTS: 'SUCCESS_SUPPORT_DEPARTMENTS',

    START_NEW_SUPPORT_CONVERSATIONS: 'START_NEW_SUPPORT_CONVERSATIONS',
    SUCCESS_NEW_SUPPORT_CONVERSATIONS: 'SUCCESS_NEW_SUPPORT_CONVERSATIONS',
    FINISH_NEW_SUPPORT_CONVERSATIONS: 'FINISH_NEW_SUPPORT_CONVERSATIONS',
    FAILURE_NEW_SUPPORT_CONVERSATIONS: 'FAILURE_NEW_SUPPORT_CONVERSATIONS',

    START_REPLY_SUPPORT_CONVERSATIONS: 'START_REPLY_SUPPORT_CONVERSATIONS',
    SUCCESS_REPLY_SUPPORT_CONVERSATIONS: 'SUCCESS_REPLY_SUPPORT_CONVERSATIONS',
    FINISH_REPLY_SUPPORT_CONVERSATIONS: 'FINISH_REPLY_SUPPORT_CONVERSATIONS',
    FAILURE_REPLY_SUPPORT_CONVERSATIONS: 'FAILURE_REPLY_SUPPORT_CONVERSATIONS',

    START_ARCHIVE_SUPPORT_CONVERSATIONS: 'START_ARCHIVE_SUPPORT_CONVERSATIONS',
    SUCCESS_ARCHIVE_SUPPORT_CONVERSATIONS: 'SUCCESS_ARCHIVE_SUPPORT_CONVERSATIONS',
    FINISH_ARCHIVE_SUPPORT_CONVERSATIONS: 'FINISH_ARCHIVE_SUPPORT_CONVERSATIONS',
    FAILURE_ARCHIVE_SUPPORT_CONVERSATIONS: 'FAILURE_ARCHIVE_SUPPORT_CONVERSATIONS',

    START_DOWNLOAD_FILE_SUPPORT_CONVERSATIONS: 'START_DOWNLOAD_FILE_SUPPORT_CONVERSATIONS',
    SUCCESS_DOWNLOAD_FILE_SUPPORT_CONVERSATIONS: 'SUCCESS_DOWNLOAD_FILE_SUPPORT_CONVERSATIONS',
    FINISH_DOWNLOAD_FILE_SUPPORT_CONVERSATIONS: 'FINISH_DOWNLOAD_FILE_SUPPORT_CONVERSATIONS',
    FAILURE_DOWNLOAD_FILE_SUPPORT_CONVERSATIONS: 'FAILURE_DOWNLOAD_FILE_SUPPORT_CONVERSATIONS',

    FETCH_SERVICE_PLANS: 'FETCH_SERVICE_PLANS',
    SUCCESS_FETCH_SERVICE_PLANS: 'SUCCESS_FETCH_SERVICE_PLANS',

    FETCH_SERVICE_FEES_SCHEDULE: 'FETCH_SERVICE_FEES_SCHEDULE',
    SUCCESS_FETCH_SERVICE_FEES_SCHEDULE: 'SUCCESS_FETCH_SERVICE_FEES_SCHEDULE',

    FETCH_SERVICE_FEES_SCHEDULE_NO: 'FETCH_SERVICE_FEES_SCHEDULE_NO',
    SUCCESS_FETCH_SERVICE_FEES_SCHEDULE_NO: 'SUCCESS_FETCH_SERVICE_FEES_SCHEDULE_NO',
    FINISH_FETCH_SERVICE_FEES_SCHEDULE_NO: 'FINISH_FETCH_SERVICE_FEES_SCHEDULE_NO',

    FETCH_SYSTEM_SETTINGS: 'FETCH_SYSTEM_SETTINGS',
    SUCCESS_FETCH_SYSTEM_SETTINGS: 'SUCCESS_FETCH_SYSTEM_SETTINGS',

    START_SERVICE_PLAN: 'START_SERVICE_PLAN',
    SUCCESS_SERVICE_PLAN: 'SUCCESS_SERVICE_PLAN',
    FINISH_SERVICE_PLAN: 'FINISH_SERVICE_PLAN',
    FAILURE_SERVICE_PLAN: 'FAILURE_SERVICE_PLAN',

    START_GET_DOCUMENT_FORMDATA: 'START_GET_DOCUMENT_FORMDATA',
    SUCCESS_GET_DOCUMENT_FORMDATA: 'SUCCESS_GET_DOCUMENT_FORMDATA',
    FINISH_GET_DOCUMENT_FORMDATA: 'FINISH_GET_DOCUMENT_FORMDATA',
    FAILURE_GET_DOCUMENT_FORMDATA: 'FAILURE_GET_DOCUMENT_FORMDATA',

    START_GET_DYNAMIC_FORM: 'START_GET_DYNAMIC_FORM',
    SUCCESS_GET_DYNAMIC_FORM: 'SUCCESS_GET_DYNAMIC_FORM',
    FINISH_GET_DYNAMIC_FORM: 'FINISH_GET_DYNAMIC_FORM',
    FAILURE_GET_DYNAMIC_FORM: 'FAILURE_GET_DYNAMIC_FORM',

    START_UPDATE_DYNAMIC_FORM: 'START_UPDATE_DYNAMIC_FORM',
    FAILURE_UPDATE_DYNAMIC_FORM: 'FAILURE_UPDATE_DYNAMIC_FORM',

    START_DOCUMENT_REQUEST_FORM: 'START_DOCUMENT_REQUEST_FORM',
    SUCCESS_DOCUMENT_REQUEST_FORM: 'SUCCESS_DOCUMENT_REQUEST_FORM',
    FINISH_DOCUMENT_REQUEST_FORM: 'FINISH_DOCUMENT_REQUEST_FORM',
    FAILURE_DOCUMENT_REQUEST_FORM: 'FAILURE_DOCUMENT_REQUEST_FORM',

    START_DYNAMIC_FORM_SUBMIT: 'START_DYNAMIC_FORM_SUBMIT',
    SUCCESS_DYNAMIC_FORM_SUBMIT: 'SUCCESS_DYNAMIC_FORM_SUBMIT',
    FINISH_DYNAMIC_FORM_SUBMIT: 'FINISH_DYNAMIC_FORM_SUBMIT',
    FAILURE_DYNAMIC_FORM_SUBMIT: 'FAILURE_DYNAMIC_FORM_SUBMIT',

    START_COMPANY_REGISTER_FORM: 'START_COMPANY_REGISTER_FORM',
    SUCCESS_COMPANY_REGISTER_FORM: 'SUCCESS_COMPANY_REGISTER_FORM',
    FINISH_COMPANY_REGISTER_FORM: 'FINISH_COMPANY_REGISTER_FORM',
    FAILURE_COMPANY_REGISTER_FORM: 'FAILURE_COMPANY_REGISTER_FORM',

    START_BUSINESS_REGISTRATION: 'START_BUSINESS_REGISTRATION',
    SUCCESS_BUSINESS_REGISTRATION: 'SUCCESS_BUSINESS_REGISTRATION',
    FINISH_BUSINESS_REGISTRATION: 'FINISH_BUSINESS_REGISTRATION',
    FAILURE_BUSINESS_REGISTRATION: 'FAILURE_BUSINESS_REGISTRATION',

    START_GET_NOTIFICATION: 'START_GET_NOTIFICATION',
    SUCCESS_GET_NOTIFICATION: 'SUCCESS_GET_NOTIFICATION',
    FINISH_GET_NOTIFICATION: 'FINISH_GET_NOTIFICATION',
    FAILURE_GET_NOTIFICATION: 'FAILURE_GET_NOTIFICATION',

    START_POST_NOTIFICATION: 'START_POST_NOTIFICATION',
    SUCCESS_POST_NOTIFICATION: 'SUCCESS_POST_NOTIFICATION',
    FINISH_POST_NOTIFICATION: 'FINISH_POST_NOTIFICATION',
    FAILURE_POST_NOTIFICATION: 'FAILURE_POST_NOTIFICATION',

    START_SUBMIT_COMPANY_FORM_DOCUMENT: 'START_SUBMIT_COMPANY_FORM_DOCUMENT',
    SUCCESS_SUBMIT_COMPANY_FORM_DOCUMENT: 'SUCCESS_SUBMIT_COMPANY_FORM_DOCUMENT',
    FINISH_SUBMIT_COMPANY_FORM_DOCUMENT: 'FINISH_SUBMIT_COMPANY_FORM_DOCUMENT',
    FAILURE_SUBMIT_COMPANY_FORM_DOCUMENT: 'FAILURE_SUBMIT_COMPANY_FORM_DOCUMENT',

    START_CHANGE_MAIN_CURRENCY: 'START_CHANGE_MAIN_CURRENCY',
    SUCCESS_CHANGE_MAIN_CURRENCY: 'SUCCESS_CHANGE_MAIN_CURRENCY',
    FINISH_CHANGE_MAIN_CURRENCY: 'FINISH_CHANGE_MAIN_CURRENCY',
    FAILURE_CHANGE_MAIN_CURRENCY: 'FAILURE_CHANGE_MAIN_CURRENCY',

    GET_USER_SETTINGS: 'GET_USER_SETTINGS',
    SUCCESS_GET_USER_SETTINGS: 'SUCCESS_GET_USER_SETTINGS',

    START_USER_SETTINGS: 'START_USER_SETTINGS',
    SUCCESS_USER_SETTINGS: 'SUCCESS_USER_SETTINGS',
    FAILURE_USER_SETTINGS: 'FAILURE_USER_SETTINGS',

    GET_COMPANIES_MEMBERS: 'GET_COMPANIES_MEMBERS',
    SUCCESS_GET_COMPANIES_MEMBERS: 'SUCCESS_GET_COMPANIES_MEMBERS',

    GET_COMPANIES_MEMBERS_GROUPS: 'GET_COMPANIES_MEMBERS_GROUPS',
    SUCCESS_GET_COMPANIES_MEMBERS_GROUPS: 'SUCCESS_GET_COMPANIES_MEMBERS_GROUPS',

    START_COMPANIES_MEMBER: 'START_COMPANIES_MEMBER',
    SUCCESS_COMPANIES_MEMBER: 'SUCCESS_COMPANIES_MEMBER',
    FINISH_COMPANIES_MEMBER: 'FINISH_COMPANIES_MEMBER',
    FAILURE_COMPANIES_MEMBER: 'FAILURE_COMPANIES_MEMBER',

    START_PUT_COMPANIES_MEMBER_GROUP: 'START_PUT_COMPANIES_MEMBER_GROUP',
    SUCCESS_PUT_COMPANIES_MEMBER_GROUP: 'SUCCESS_PUT_COMPANIES_MEMBER_GROUP',
    FINISH_PUT_COMPANIES_MEMBER_GROUP: 'FINISH_PUT_COMPANIES_MEMBER_GROUP',
    FAILURE_PUT_COMPANIES_MEMBER_GROUP: 'FAILURE_PUT_COMPANIES_MEMBER_GROUP',

    START_REMOVE_COMPANIES_MEMBER_GROUP: 'START_REMOVE_COMPANIES_MEMBER_GROUP',
    SUCCESS_REMOVE_COMPANIES_MEMBER_GROUP: 'SUCCESS_REMOVE_COMPANIES_MEMBER_GROUP',
    FINISH_REMOVE_COMPANIES_MEMBER_GROUP: 'FINISH_REMOVE_COMPANIES_MEMBER_GROUP',
    FAILURE_REMOVE_COMPANIES_MEMBER_GROUP: 'FAILURE_REMOVE_COMPANIES_MEMBER_GROUP',

    START_GET_FILE: 'START_GET_FILE',
    SUCCESS_GET_FILE: 'SUCCESS_GET_FILE',
    FINISH_GET_FILE: 'FINISH_GET_FILE',
    FAILURE_GET_FILE: 'FAILURE_GET_FILE',

    START_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: 'START_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS',
    SUCCESS_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: 'SUCCESS_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS',
    FINISH_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: 'FINISH_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS',
    FAILURE_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: 'FAILURE_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS',
}

export default SettingsActionTypes
